import { alpha, Box, Typography } from '@mui/material';
import { getPaymentPlatformIcon } from '../../paymentPlatform';

const PaymentPlatformCard = ({ id, name, isSelected = false, handlePaymentPlatform = () => {}, disabled = false }) => {
    const animations = disabled
        ? {}
        : {
              cursor: 'pointer',
              transition: 'all 0.18s ease',
              '&:hover': {
                  borderColor: '#137DC5',
                  boxShadow: '0 6px 16px rgba(0,0,0,0.12)',
                  transform: 'translateY(-1px)',
              },
              '&:active': {
                  transform: 'scale(0.98)',
                  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
              },
          };

    return (
        <Box
            sx={{
                padding: '12px 8px',
                borderRadius: 1,
                border: `solid 1px ${isSelected ? '#137DC5' : alpha('#131313', 0.25)}`,
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                backgroundColor: isSelected ? alpha('#137DC5', 0.1) : 'white',
                boxShadow: isSelected ? '0 4px 12px rgba(19, 125, 197, 0.25)' : '0 1px 4px rgba(0,0,0,0.08)',
                scale: isSelected ? 1.05 : 1,
                ...animations,
            }}
            onClick={() => {
                if (disabled) return;

                return handlePaymentPlatform(id);
            }}
        >
            {getPaymentPlatformIcon(id, disabled)}
            <Typography fontSize={16} fontWeight={700} sx={{ color: alpha('#131313', disabled ? 0.75 : 1), maxWidth: '100%' }} noWrap>
                {name}
            </Typography>
        </Box>
    );
};

export default PaymentPlatformCard;
